(function () {
  'use strict';
  var states = new WeakMap();

  function element(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function readCard(source) {
    var name = source.querySelector('.jdgm-review-card__name');
    var body = source.querySelector('.jdgm-review-card__body');
    var rating = source.querySelector('.jm-star-rating[aria-label]');
    if (!name || !body || !rating) return null;
    var score = Number((rating.getAttribute('aria-label').match(/^[0-5](?:\.[0-9]+)?/) || [])[0]);
    if (!Number.isInteger(score) || score < 1 || score > 5) return null;
    var paragraphs = Array.from(source.querySelectorAll('p.jm-text'));
    var date = paragraphs.find(function (p) { return /^\d{2}\/\d{2}\/\d{4}$/.test(p.textContent.trim()); });
    var shopBadge = source.querySelector('.jm-verified-by-shop-badge img');
    var verified = source.querySelector('.jm-verified-buyer-badge, .jm-verified-badge');
    var origin = source.querySelector('.jm-transparency-badge-list');
    return {
      name: name.textContent.trim(),
      body: body.textContent.trim(),
      score: score,
      date: date ? date.textContent.trim() : '',
      verified: shopBadge ? shopBadge.alt : (verified ? verified.textContent.trim() : ''),
      origin: origin ? origin.textContent.trim() : ''
    };
  }

  function card(review) {
    var node = element('article', 'squad-review-card squad-review-card--no-image');
    var header = element('div', 'squad-review-card__header');
    var avatar = element('span', 'squad-review-card__avatar', review.name.charAt(0));
    avatar.setAttribute('aria-hidden', 'true');
    header.appendChild(avatar);
    var identity = element('div', 'squad-review-card__identity');
    var line = element('div', 'squad-review-card__name-line');
    line.appendChild(element('span', 'squad-review-card__name', review.name));
    if (review.verified) line.appendChild(element('span', 'squad-review-card__verified', review.verified));
    identity.appendChild(line);
    if (review.date) identity.appendChild(element('span', 'squad-review-card__date', review.date));
    header.appendChild(identity);
    node.appendChild(header);
    var stars = element('div', 'squad-review-card__stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', review.score + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) {
      var star = element('span', i <= review.score ? '' : 'squad-review-card__star--off', i <= review.score ? '★' : '☆');
      star.setAttribute('aria-hidden', 'true');
      stars.appendChild(star);
    }
    node.appendChild(stars);
    node.appendChild(element('p', 'squad-review-card__text', review.body));
    if (review.origin) node.appendChild(element('span', 'ss-review-origin', review.origin));
    return node;
  }

  function row(reviews, reverse) {
    var viewport = element('div', 'squad-review-row');
    var track = element('div', 'squad-review-track' + (reverse ? ' squad-review-track--reverse' : ''));
    var group = element('div', 'squad-review-group');
    reviews.forEach(function (review) { group.appendChild(card(review)); });
    track.appendChild(group);
    var duplicate = group.cloneNode(true);
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.inert = true;
    track.appendChild(duplicate);
    viewport.appendChild(track);
    return viewport;
  }

  function enhance(widget) {
    // Keep product-specific reviews and their filtering in the app's native UI.
    if (!widget.querySelector('.jm-other-products-reviews-text')) return;
    var grid = widget.querySelector('.jdgm-masonry-grid');
    if (!grid) return;
    var sources = Array.from(grid.querySelectorAll('.jdgm-review-card'));
    var reviews = sources.map(readCard);
    if (reviews.length < 4 || reviews.some(function (review) { return !review; })) return;
    var signature = JSON.stringify(reviews);
    var old = states.get(widget);
    if (old && old.root.isConnected && (old.expanded || old.signature === signature)) return;
    if (old) old.root.remove();

    var root = element('div', 'ss-product-review-preview');
    var marquee = element('div', 'squad-review-marquee');
    marquee.setAttribute('role', 'region');
    marquee.setAttribute('aria-label', 'Reviews for other products');
    var split = Math.ceil(reviews.length / 2);
    marquee.appendChild(row(reviews.slice(0, split), false));
    marquee.appendChild(row(reviews.slice(split), true));
    root.appendChild(marquee);
    var controls = element('div', 'ss-product-review-controls');
    var pause = element('button', 'ss-product-review-control ss-product-review-pause', 'Pause reviews');
    pause.type = 'button';
    pause.setAttribute('aria-pressed', 'false');
    pause.addEventListener('click', function () {
      var paused = root.dataset.paused !== 'true';
      root.dataset.paused = String(paused);
      pause.setAttribute('aria-pressed', String(paused));
      pause.textContent = paused ? 'Resume reviews' : 'Pause reviews';
    });
    var all = element('button', 'ss-product-review-control', 'Read all reviews');
    all.type = 'button';
    all.setAttribute('aria-expanded', 'false');
    var state = { root: root, signature: signature, expanded: false };
    all.addEventListener('click', function () {
      state.expanded = !state.expanded;
      marquee.hidden = state.expanded;
      pause.hidden = state.expanded;
      all.setAttribute('aria-expanded', String(state.expanded));
      all.textContent = state.expanded ? 'Show scrolling reviews' : 'Read all reviews';
      if (state.expanded) {
        grid.removeAttribute('data-ss-review-preview');
        grid.removeAttribute('aria-hidden');
        requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
      } else {
        grid.dataset.ssReviewPreview = 'true';
        grid.setAttribute('aria-hidden', 'true');
        enhance(widget);
      }
    });
    controls.appendChild(pause);
    controls.appendChild(all);
    root.appendChild(controls);
    states.set(widget, state);
    grid.before(root);
    grid.dataset.ssReviewPreview = 'true';
    grid.setAttribute('aria-hidden', 'true');
  }

  function watch(widget) {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; enhance(widget); });
    }
    new MutationObserver(schedule).observe(widget, { childList: true, subtree: true });
    schedule();
  }

  function start() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (widget) return watch(widget);
    var waiting = new MutationObserver(function () {
      var loaded = document.getElementById('judgeme_product_reviews');
      if (loaded) { waiting.disconnect(); watch(loaded); }
    });
    waiting.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
